export default "__VITE_ASSET__FtQMAKOz__"